import jQuery from 'jquery';
window.jQuery = jQuery;
import 'bootstrap/dist/js/bootstrap.bundle';
import './jscookie';
import './custom';
import './ads';
import './adaptiveConfig';